function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F4F4F4",
    style: {
      fill: "#F4F4F4",
      fill: "color(display-p3 0.9569 0.9569 0.9569)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 16.4996C14.3734 16.4996 16.5 14.373 16.5 11.7496C16.5 9.12625 14.3734 6.9996 11.75 6.9996C9.12665 6.9996 7 9.12625 7 11.7496C7 14.373 9.12665 16.4996 11.75 16.4996Z",
    stroke: "#959595",
    style: {
      stroke: "#959595",
      stroke: "color(display-p3 0.5843 0.5843 0.5843)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9996L16 15.9996",
    stroke: "#959595",
    style: {
      stroke: "#959595",
      stroke: "color(display-p3 0.5843 0.5843 0.5843)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSearchIcon);
export default __webpack_public_path__ + "static/media/circle-search-icon.feadd4523df5afed8793f1984674f1ef.svg";
export { ForwardRef as ReactComponent };